// extracted by mini-css-extract-plugin
module.exports = {"hero":"styles-module--hero--2Siq7","logo":"styles-module--logo--3X8IB"};